import React from 'react';
import InfoRow from 'components/Info/InfoRow';
import { translate } from 'components/Translation';
import { HeadingMBold, HeadingSBold, HeadingLBold } from 'components/Typography/Typography';
import styles from 'assets/jss/material-dashboard-pro-react/views/numberDetails/activeCommitmentsStyle';
import { makeStyles } from '@material-ui/core';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';

// @ts-ignore
const useStyles = makeStyles(styles);

interface SummaryCardProps {
	value: number;
}

const SummaryCard = ({ value }: SummaryCardProps) => {
	const classes = useStyles();

	return (
		<div className={classes.summary}>
			<Card>
				<CardBody>
					<HeadingLBold color="primary-light">{translate('summary')}</HeadingLBold>
					<InfoRow
						title={<HeadingSBold disableMargin>{translate('total.amount')}</HeadingSBold>}
						value={<HeadingMBold disableMargin>{translate('price', value)}</HeadingMBold>}
						noBorder
					/>
				</CardBody>
			</Card>
		</div>
	);
};

export default SummaryCard;
